import PersonalCharacteristics from "../../components/PersonalCharacteristics";
import { order } from "../SmartSearchParammeter";

export default async function PersonalCharacteristicsSearchConfig(key) {
  return {
    description: "Personal Characteristics",
    id: "personalCharacteristics",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <PersonalCharacteristics searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["personalCharacteristics"] = value[0];
    }
  };
}
